import System from "./System";
import TemplateApis from "./Template";
import AuthApis from "./auth"
import ProductApis from './product'
import VideoApis from "./video";
import UserApis from './user'

export {
    System,
    TemplateApis,
    AuthApis,
    ProductApis,
    VideoApis,
    UserApis,
}